import * as React from "react";
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import UserMenu from "./UserMenu";
import logo from '../images/logos/app_header_logo.png';
import LoginRegisterButtons from './LoginRegisterButtons';

const styles = (theme: Theme) => createStyles({
  header: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  mobileHeader: {
    alignItems: 'flex-end',
  },
  secondaryTitle: {
    fontSize: 16,
    color: '#F7F8F9',
    fontFamily: 'Montserrat',
    letterSpacing: 0.57,
    fontWeight: 600,
    marginLeft: 10,
    marginBottom: 2
  },
  secondaryTitleMobile: {
    fontSize: 12,
    color: '#F7F8F9',
    fontFamily: 'Montserrat',
    letterSpacing: 0.57,
    fontWeight: 500,
    // marginLeft: 10,
    marginBottom: 2
  },
  
});

interface HeaderProps {
  userLoggedIn: boolean;
  passwordChangeRequired: boolean;
}

const Header: React.StatelessComponent<WithStyles & HeaderProps & RouteComponentProps> = ({
  classes,
  userLoggedIn,
  passwordChangeRequired
}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return (
    <Grid container justify="space-between" className={isMobile === false ? "App-header" : "App-header-mobile"}>
      <header className={isMobile === false ? classes.header : classes.mobileHeader}>
        <Link to="/">
          <img src={logo} height={isMobile === false ? 60: 40} />
        </Link>
        <div className={isMobile === false ? classes.secondaryTitle : classes.secondaryTitleMobile}>
          by Port of Hanko Ltd.
        </div>
      </header>
      {userLoggedIn && !passwordChangeRequired ? (
        <UserMenu />
      ) : (
        <LoginRegisterButtons />
      )}
    </Grid>
  );
};

export default withRouter(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./src/common/Header.tsx